import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { SolanaWalletProvider } from '../SolanaWalletProvider';
import { SolanaCreatorFormContent } from './SolanaCreatorFormContent';

// Solana Brand Colors
const SOL_PURPLE = '#9945FF';
const SOL_GREEN = '#14F195';

interface CreateSolanaTokenModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess?: () => void;
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
`;

const ModalContent = styled.div`
  background: #000000;
  border: 1px solid rgba(153, 69, 255, 0.3);
  border-radius: 16px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: 32px;
  box-sizing: border-box;
  box-shadow: 0 10px 40px rgba(153, 69, 255, 0.2);
  position: relative;
  
  @media (max-width: 700px) {
    padding: 24px 16px;
    max-width: 95%;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  color: #FFFFFF !important;
  font-size: 32px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
  z-index: 10;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: rotate(90deg);
  }
`;

const CreateSolanaTokenModal: React.FC<CreateSolanaTokenModalProps> = ({
    isOpen,
    onClose,
    onSuccess
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Create Solana Token"
            ariaHideApp={false}
            style={{
                overlay: {
                    backgroundColor: 'rgba(0,0,0,0.85)',
                    zIndex: 1000,
                    backdropFilter: 'blur(8px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                content: {
                    maxWidth: '800px',
                    margin: 'auto',
                    borderRadius: '16px',
                    background: 'transparent',
                    border: 'none',
                    padding: 0,
                    inset: 'auto',
                    position: 'relative'
                },
            }}
        >
            <ModalContent>
                <CloseButton onClick={onClose}>×</CloseButton>
                <SolanaWalletProvider>
                    <SolanaCreatorFormContent onSuccess={onSuccess} onClose={onClose} />
                </SolanaWalletProvider>
            </ModalContent>
        </Modal>
    );
};

export default CreateSolanaTokenModal;

